import { Component,Renderer2,ElementRef,  ViewChild, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/utilities/auth.service';
import { Debug } from 'src/app/utils/debug';
import { SocialMediaAPIService } from 'src/app/services/utilities/socialMediaApi.service';
import { PostService } from 'src/app/services/repositories/post.service';
import { catchError } from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { StatsIcon } from 'src/app/enums/statsSVGIcon';
import { ScreenSizeService } from 'src/app/services/utilities/screen-size.service';
import { TranslationService } from 'src/app/services/utilities/translation.service';
import { BaseComponent } from 'src/app/components/base/base.component';
import { ICON } from 'src/app/interfaces/ModalIcon';
import { WebSocketService } from 'src/app/services/utilities/websocket.service';

@Component({
  selector: 'app-post-details',
  templateUrl: './post-details.component.html',
  styleUrls: ['./post-details.component.scss']
})
export class PostDetailsComponent extends BaseComponent {

  groupsDropDown: boolean = false;
  pagesDropDown: boolean = false;
  isLoading: boolean = true;
  selectedPlateform: string = '';
  data: any = {};
  saveData: string = '';
  writeReply: any = null;
	targetPage: any = null;
	currentPostAvatar: any = null;
  pages: any[] = [];
  groups: any[] = [];
  platformPages: any[] = [];
  environment = environment;
  textpost: string =  "Ce texte latin, généralement utilisé, proviendrait d'un texte latin écrit par Cicéron en 45 avant J.-C., sans copier le texte original au complet, il reprendrait seulement certaines parties et ajouterait des fautes. Ainsi, le mot lorem proviendrait du latin dolorem donnant la traduction de dolorem ipsum : la douleur."
  noData : boolean = false;
  all: boolean = false;
	platformFlags: { [key: string]: boolean } = {};
  linkedinPages: any[] = [];
  googlePages: any[] = [];
  facebookPages: any[] = [];
  instagramPages: any[] = [];
  linkedinInsights: any = {};
  facebookInsights: any = {};
  instagramInsights: any = {};
  linkedinData: any = [];
  googleData: any = [];
  facebookData: any = [];
  instagramData: any = [];
  allData: any = {};
	actionDropdown: boolean = false;
	user: any = null;
  screenHeight : number = 0;
  screenWidth : number = 0;
  groupScopes: number[] = [];
  nbOfLinkedindPages: number = 1;
  reactionsView: boolean = false;

	// Delete post modal
	confirmDeleteModalVisible: boolean = false;

  //comments
  currentComment:any=null;

	modalIcon: ICON = ICON.delete;
	modalHeading: string = '';
	modalSubHeading: string = '';
	modalHideElements: boolean = false;
	modalShowLoadingDots: boolean = false;
  subscriptions: Subscription[] = [];
  constructor(
		translationService: TranslationService,
    private eRef: ElementRef,
    private renderer: Renderer2,
    private authService: AuthService,
    private socialMediaAPIService: SocialMediaAPIService,
    protected postService:PostService,
    private screenSizeService: ScreenSizeService,
    private router: Router,
		private webSocketService: WebSocketService,

  ){
		super(translationService);
	}

  ngOnInit(){
    this.loadUser();
    this.subscriptions.push( this.screenSizeService.screenWidth$.subscribe((width: number) => this.screenWidth = width));
    this.subscriptions.push(this.screenSizeService.screenHeight$.subscribe((height: number) => this.screenHeight = height));
    this.groupScopes = this.postService.getGroupScopesFromLocalStorage()
    //fetch Posts by id from url
    const postId = document.URL.split('/')[document.URL.split('/').length-1]

    this.getPost(postId)
    this.subscriptions.push(this.postService.currentGroups.subscribe(
      (groups) => {
        // this.isLoading = true;
        this.groupScopes = groups;
        // this.reinitializeData()
        if(this.saveData != ''){
          this.reinitializeData()
          // this.data = JSON.parse(this.saveData)
          this.prepareData()
        }
      }
    ));



		//Listend To post deletion via Websocket
		this.webSocketService.connect();
		this.webSocketService.listen('postDeletionCompleted', (data: any) => {

      const { post, fullyDeleted } = data;


			const postId = parseInt(post.id);

			const remainingJobs = (this.deletionJobCounts.get(postId) || 0) - 1;
			console.log("remainingJobs", remainingJobs)
			if (remainingJobs <= 0) {
				// Remove the element if remainingJobs is 0 or less
				this.deletionJobCounts.delete(postId);
				this.modalIcon = ICON.success;
				this.modalShowLoadingDots = false;
				this.modalHeading = 'generic.deleted';
				this.modalSubHeading = ' ';
				setTimeout(() => {
          // this.confirmDeleteModalVisible = false;
					this.router.navigate(['/library']);
        }, 1500);
			} else {
				// Otherwise, update the count
				this.deletionJobCounts.set(postId, remainingJobs);
			}


      // // Find the post in the list and update UI
      // const postIndex = this.posts.findIndex((post: any) => post.id === postId);

      // if (postIndex !== -1) {

      //   if (fullyDeleted) {
      //     // All platforms deleted, remove the post
      //     this.posts.splice(postIndex, 1);
      //   } else {
      //     // Update post's platforms
      //     this.posts[postIndex] = post;
      //     // this.deletionInProgress.delete(postId); // Remove from in-progress
      //   }
      // }
    });
	}


  getPost(postId: string){
    this.subscriptions.push(this.postService.getPostById(postId, true,this.groupScopes).pipe(
      catchError((error: any) => {
        if (error.status === 403) {
          window.location.href = "/not-allowed";
        }
        if (error.status === 404) {
          window.location.href = "/not-exists";
        }
        if (error.status === 500) {
          window.location.href = "/error";
        }
        // Return an empty observable to terminate further processing
        return of(null);
      })
    ).subscribe((res: any) => {
       console.log(res)
      //this.data is the current
      this.data = res.data
      const InstaPages=this.data.SocialPlatforms.filter((p:any)=>p.source=="instagram")
      // console.info('InstaPages', InstaPages[0]);


      //this.fetchInsights();
      this.saveData = JSON.stringify(this.data)
      this.prepareData();
      this.isLoading = false;

    }))
  }

  prepareData(){
    let list: any[] = [];
    this.data.SocialPlatforms = this.data.SocialPlatforms.filter((item: any) => {
      if(!list.includes(item.group.id)){
        this.groups.push({id: item.group.id, name: item.group.name});
        list.push(item.group.id);
      }
      return this.groupScopes.includes(item.group.id);
    });
    // console.log('list',list);
    this.data.SocialPlatforms.forEach((item:any)=>{
      if(item.source == "linkedin"){
        this.linkedinData.push(item);
        if(!this.isNotEmptyObject(this.linkedinInsights) && item?.postAnalytics){
          item.postAnalytics.clickRate = item.postAnalytics?.clickRate == "0.00" ? 0 : item.postAnalytics?.clickRate
          item.postAnalytics.engagementRate = item.postAnalytics?.engagementRate == "0.00" ? 0 : item.postAnalytics?.engagementRate
          this.linkedinInsights.postAnalytics = item?.postAnalytics
        }
        else if(item.postAnalytics){
          this.nbOfLinkedindPages += 1;
          this.sumLinkedinPostAnalytics();
        }
        // console.log('this.linkedinInsights.postAnalytics.clickRate', this.linkedinInsights?.postAnalytics?.clickRate );
        this.linkedinPages.push({'name':item.pageName, "url": "https://www.linkedin.com/feed/update/"+item.externalId, "source": item.source});
        this.pages.push({'name':item.pageName, "url": "https://www.linkedin.com/feed/update/"+item.externalId, "source": item.source});
      }
      else if(item.source == "google"){
        // this.googleData = item;
        this.googlePages.push({'name':item.pageName, "url": item.additionalData?.post_url? item.additionalData?.post_url: item.url , "source": item.source});
        this.pages.push({'name':item.pageName, "url": item.url, "source": item.source});
      }
      else if(item.source == "facebook"){
        this.facebookData.push(item);
        if(!this.isNotEmptyObject(this.facebookInsights) && item?.postAnalytics){
          item.postAnalytics.comments = this.countFbComments(item);
          this.calculFbInteractions(item?.postAnalytics);
          this.facebookInsights.postAnalytics = item.postAnalytics
        }
        else if(item.postAnalytics){
          item.postAnalytics.comments = this.countFbComments(item);
          this.calculFbInteractions(item?.postAnalytics);
          this.sumFBPostAnalytics()
        }
        this.facebookPages.push({'name':item.pageName, "url": "https://www.facebook.com/"+item.externalId, "source": item.source});
        this.pages.push({'name':item.pageName, "url": "https://www.facebook.com/"+item.externalId, "source": item.source});
      }
      else if(item.source == "instagram"){
        this.instagramData.push(item);
        if(!this.isNotEmptyObject(this.instagramInsights) && item?.postAnalytics)
          this.instagramInsights.postAnalytics = item.postAnalytics
        else if(item.postAnalytics)
          this.suminstagramPostAnalytics()
        this.instagramPages.push({'name':item.pageName, "url": item.additionalData?.post_url, "source": item.source});
        this.pages.push({'name':item.pageName, "url": item.additionalData?.post_url?item.additionalData?.post_url:item.url, "source": item.source});
      }
    })
    this.allStats();
    if(this.nbOfLinkedindPages > 1){
      // Calculer les taux
      let clickRate = this.linkedinInsights.postAnalytics.clickRate / this.nbOfLinkedindPages;
      let engagementRate = this.linkedinInsights.postAnalytics.engagementRate / this.nbOfLinkedindPages;

      // Vérifier si le nombre contient une virgule
      this.linkedinInsights.postAnalytics.clickRate = (clickRate % 1 === 0) ? clickRate : clickRate.toFixed(2);
      this.linkedinInsights.postAnalytics.engagementRate = (engagementRate % 1 === 0) ? engagementRate : engagementRate.toFixed(2);

    }

    if(this.data.SocialPlatforms.length == 0){
      this.data = {}
      this.noData = true;
    }else{
      this.noData = false;
      this.chooseSelectedPlateform();
    }

  }

  chooseSelectedPlateform(){
    const platforms = ["linkedin", "google", "facebook", "instagram"];
    // Extract unique platforms from the data
    const uniquePlatforms = new Set<string>(
      this.data.SocialPlatforms
        .map((item: { source: string }) => item.source)
        .filter((source:string) => platforms.includes(source))
    );

    // Set the platform flags based on the unique platforms
    uniquePlatforms.forEach(platform => {
      this.platformFlags[platform] = true;
    });

    // Count the number of sources
    const numberOfSources = uniquePlatforms.size;

    if (numberOfSources > 1) {
      this.all = true;
      this.selectedPlateform = 'all'
    }
    else{
      this.selectPlateform(this.data.SocialPlatforms[0].source)
    }
  }

	loadUser() {
		this.subscriptions.push(this.authService.loadCurrentUser().subscribe((res) => {
			this.user = res?.data
		}))
	}

	fetchInsights() {
		let postId = this.data.id;
		this.data.SocialPlatforms.forEach((socialPlatform: any) => {
      const platform = socialPlatform.source.toLowerCase();
      if(this.groupScopes.includes(socialPlatform.group.id)){
        if (platform === "facebook" || platform === "linkedin" || platform === "instagram") {
          const socialMediaId = socialPlatform.id; // Define `socialMediaId` locally

          if (platform === "facebook") {
           this.subscriptions.push( this.socialMediaAPIService.fetchPostInsights(postId, socialMediaId).subscribe((res: any) => {
              socialPlatform.postAnalytics = res.data.postAnalytics
            }));
          }
          if (platform === "linkedin") {
            this.subscriptions.push(this.socialMediaAPIService.fetchPostInsights(postId, socialMediaId).subscribe((res: any) => {
              socialPlatform.postAnalytics = res.data.postAnalytics
            }));
          }
          if (platform === "instagram") {
            this.subscriptions.push(this.socialMediaAPIService.fetchPostInsights(postId, socialMediaId).subscribe((res: any) => {
              socialPlatform.postAnalytics = res.data.postAnalytics
            }));
          }
        }
      }
		});


    //load comment if linkedin is active
    // if(this.selectedPlateform=="linkedin"){
    //   //this.platformPages = this.linkedinData.comments
		// 	//this.selectFirstComment()
    // }
	}

  getPages(){
    switch( this.selectedPlateform){
      case "linkedin":return this.linkedinPages;
      case "google":return this.googlePages;
      case "facebook":return this.facebookPages;
      case "instagram":return this.instagramPages;
    }
    return this.pages
  }

  selectPlateform(plateform: string){
    this.currentComment = null
    if(this.isCommentsLoading )return
    switch (plateform){
      case 'linkedin':
        this.selectedPlateform = 'linkedin';
        this.fetchPostCommentsByPlatform(this.linkedinData)
        break;
      case 'google':
        this.selectedPlateform = 'google';
        break;
      case 'facebook':
        this.selectedPlateform = 'facebook';
        this.fetchPostCommentsByPlatform(this.facebookData)
        break;
      case 'instagram':
        this.selectedPlateform = 'instagram';
        this.fetchPostCommentsByPlatform(this.instagramData)
         break;
      default:
        this.selectedPlateform = 'all';
    }
    this.isLoading = false;
  }

  isCommentsLoading:boolean = false
  fetchPostCommentsByPlatform(pagesComments:any[]){
    if(!this.userHasPermission('publication.post.api-comment')) return;
    const commentFetchData = {postId: this.data.id, socialMediaIds: pagesComments.map(page => page.id)}
		// ⚠️ platformPages is unconditionally reset after getPostComments subscription, so this loop seem useless. Commented for now
    // this.platformPages = []
    // for (let page of pagesComments) {
    //   this.platformPages.push({socialMediaId: page.id ,source: page.source, name: page.pageName, comments: page.comments, pageLogoUrl: page.pageLogoUrl})
    // }
    this.isCommentsLoading=true
    this.facebookData=[]
    this.postService.getPostComments(commentFetchData).subscribe((res:any)=>{

      this.facebookData =  [...this.data.SocialPlatforms.filter((sm:any)=>sm.source==="facebook")]
      this.instagramData = [...this.data.SocialPlatforms.filter((sm:any)=>sm.source==="instagram")]
      this.linkedinData =  [...this.data.SocialPlatforms.filter((sm:any)=>sm.source==="linkedin")]
      this.data.SocialPlatforms.forEach((socialPlatform: any) => {
        for(let r of res){
          if(socialPlatform.id === r.socialMediaId){
            socialPlatform.comments = r.comments
          }
          // if(socialPlatform.source === "facebook"){
          //   socialPlatform.postAnalytics.comments=this.countFbComments(socialPlatform)
          // }
          // if(socialPlatform.source === "linkedin"){
          //   socialPlatform.postAnalytics.comments=this.countLiComments(socialPlatform)
          // }
          // if(socialPlatform.source === "instagram"){
          // }
        }
      })

      // if(this.facebookInsights.postAnalytics)
      //   {this.facebookInsights.postAnalytics.comments = this.facebookData.map((page:any) => page.postAnalytics.comments).reduce((acc:number, curr:number) => acc + curr, 0)}
      // if(this.linkedinInsights.postAnalytics){
      //   this.linkedinInsights.postAnalytics.commentCount = this.linkedinData.map((page:any) => page.postAnalytics.comments).reduce((acc:number, curr:number) => acc + curr, 0)
      // }
      this.platformPages = res
      this.isCommentsLoading = false
    })

  }

  getSRCByPlatform(){
    if(this.selectedPlateform=='all')return ""
    return "assets/img/simple-logo-"+this.selectedPlateform+".png";
  }

  formatCommentTime(time:string){
    let x = new Date(time)
    return x.getFullYear() +"/"+(x.getMonth()+1).toString().padStart(2,'0') +"/"+x.getDate().toString().padStart(2,'0') +" - "+x.getHours().toString().padStart(2,'0') +":"+x.getMinutes().toString().padStart(2,'0')
  }

  SetIconClick() : StatsIcon { return StatsIcon.CLICK }
  SetIconShare() : StatsIcon { return StatsIcon.SHARE }
  SetIconChatBubble() : StatsIcon { return StatsIcon.CHAT_BUBBLE }
  SetIconView() : StatsIcon { return StatsIcon.VIEW }
  SetIconUserFavorite() : StatsIcon { return StatsIcon.USER_FAVORITE }
  SetIconSmilyFace() : StatsIcon { return StatsIcon.SMILY_FACE }
  SetIconHeart() : StatsIcon { return StatsIcon.HEART }
  SetIconActivity() : StatsIcon { return StatsIcon.ACTIVITY }
  SetIconBookMark() : StatsIcon { return StatsIcon.BOOKMARK }
  SetIconStar() : StatsIcon { return StatsIcon.STAR }
  SetIconReactions() : StatsIcon { return StatsIcon.REACTIONS }
  SetIconFbReactions() : StatsIcon { return StatsIcon.FBREACTIONS }
  SetIconClickRate() : StatsIcon { return StatsIcon.CLICKRATE }
  SetIconEngagement() : StatsIcon { return StatsIcon.ENGAGEMENT }
  SetIconEngagementRate() : StatsIcon { return StatsIcon.ENGAGEMENTRATE }
  SetIconImpression() : StatsIcon { return StatsIcon.IMPRESSION }
  SetIconSaved() : StatsIcon { return StatsIcon.SAVED }
  SetIconInteraction() : StatsIcon { return StatsIcon.INTERACTION }
  SetIconActivityProfil() : StatsIcon { return StatsIcon.ACTIVITYPROFIL }
  SetIconNewFans() : StatsIcon { return StatsIcon.NEWFANS }
  SetIconProfilVisit() : StatsIcon { return StatsIcon.PROFILVISIT }
  isFbReaction(): StatsIcon { return StatsIcon.FBREACTIONS }
  linkClics(): StatsIcon { return StatsIcon.LINKCLICS }

  dropdownpages(){
    this.pagesDropDown = !this.pagesDropDown;
      if (this.pagesDropDown) {
        this.renderer.listen('document', 'click', (event) => {
          if (!this.eRef.nativeElement.contains(event.target)) {
            this.pagesDropDown = false;
          }
        });
      }
  }

  dropDownOpen(type:string){
    if(type == "pages"){
      this.pagesDropDown = !this.pagesDropDown;
      this.groupsDropDown = false;
      if (this.pagesDropDown) {
        this.renderer.listen('document', 'click', (event) => {
          if (!this.eRef.nativeElement.contains(event.target)) {
            this.pagesDropDown = false;
          }
        });
      }
      return
    }
    if(type == "groups"){
      this.groupsDropDown = !this.groupsDropDown;
      this.pagesDropDown = false;
    }
  }
	noCommentsOnCurrentPlatform(){
    return this.platformPages.every(p => !p.comments || p.comments.length == 0)
  }

  reply(data: any) {
    this.currentComment = data.currentComment;
    this.writeReply = data.currentComment;
    this.targetPage = data.page;
		this.currentPostAvatar = this.currentPostAvatarFt();
  }

  message:string=""
  processComment(){
    if (this.isCommentsLoading) return
    if (this.writeReply) {
      this.sendReply()
    }
    else {
      this.sendComment()
    }
  }
  getSendButtonLabel(){
    if (this.writeReply) {
      return 'generic.reply'
    } else {
      return 'generic.comment'
    }
  }
  sendComment(){
    this.isCommentsLoading = true;
    let page = null
    switch( this.selectedPlateform){
      case "linkedin":
        page = this.linkedinData
      break;
      case "facebook":
        page = this.facebookData
      break;
      case "instagram":
        page = this.instagramData
      break;
    }
    const commentID = page.externalId

    this.subscriptions.push(this.postService.sendComment({actor: `urn:li:organization:${page.pageId}`, message: {text: this.message}, urn: commentID}, page).subscribe((res:any)=>{
      this.platformPages = res
      this.message = ""
      this.isCommentsLoading = false
    }))

  }

  sendReply(){
    // console.log("replying on comment");
    let page=this.targetPage
    let postExternalId=null

    this.data.SocialPlatforms.forEach((p:any) => {
       if(p.id == this.targetPage.socialMediaId ){
         postExternalId = p.externalId
         page = p
       }
    })
    if(this.message=="" ||postExternalId==null) return
    // console.log("patchedPage",page)

    this.isCommentsLoading =true;
    switch( this.selectedPlateform){
      case "linkedin":{
        const replyPostData = {
          actor:`urn:li:organization:${page.pageId}`,
          message: {text: this.message},
          parentComment: this.writeReply.id,
          urn: postExternalId
        }

        this.subscriptions.push(this.postService.sendReply(replyPostData,page).subscribe((res:any)=>{

          // console.log("✨",res.comments)
          for(let page of this.platformPages){
            if(res.postSocialMedia.socialMediaId ==  page.socialMediaId){
              page.comments = res.comments
            }
          }
          for(const linkedinPage of this.linkedinData){
            if(res.postSocialMedia.socialMediaId ==  page.socialMediaId){
                linkedinPage.postAnalytices=res.postSocialMedia.postAnalytices
            }
          }
          this.message = ""
          this.isCommentsLoading = false
          this.writeReply = null
          this.currentComment = null
        }))
      }
      break;

      case "facebook":{
        this.subscriptions.push(this.postService.sendReply({actor:`${page.pageId}`,message:{text:this.message},parentComment:this.writeReply.id ,externalId:postExternalId},page).subscribe((res:any)=>{
          // console.log(res)
          //update comments count
          // console.log("✨",res.comments)
          for(let page of this.platformPages){
            // console.log("{DEBUG}","pageId",page.socialMediaId,"res.postSocialMedia.socialMediaId",res.postSocialMedia.socialMediaId)
            if(res.postSocialMedia.socialMediaId ==  page.socialMediaId){
              // console.log("target page ",page.name ,"total comments :",page.comments.flat().length)
              page.comments=res.postSocialMedia.comments
            }
          }
          for(const facebookPage of this.facebookData){
            if(res.postSocialMedia.socialMediaId ==  page.socialMediaId){
              facebookPage.postAnalytices=res.postSocialMedia.postAnalytices
            }
          }
          this.message = ""
          this.isCommentsLoading = false
        }))
      }
      break;

      case "instagram":{
        this.subscriptions.push(this.postService.sendReply({actor:`urn:li:organization:${page.pageId}`,message:{text:this.message},parentComment:this.writeReply.id ,externalId:postExternalId},page).subscribe((res:any)=>{

          this.instagramData.postAnalytice = res.postAnalytics
           for(let page of this.platformPages){
            if(res.postSocialMedia.socialMediaId == page.socialMediaId){
              page.comments = res.comments
            }
          }
          for(const instagramPage of this.instagramData){
            if(res.postSocialMedia.socialMediaId ==  page.socialMediaId){
              instagramPage.postAnalytices=res.postSocialMedia.postAnalytices
            }
          }
          this.message = ""
          this.isCommentsLoading = false
        }))
      }
      break;
    }


  }
  isEmojiPickerOpen = false
  toggleImojiPicker(){
    this.isEmojiPickerOpen=!this.isEmojiPickerOpen
  }
  insertEmoji(data:any){
    this.message+=data
    this.setFocus()
  }
  @ViewChild('textarea', { static: false }) commentInput!: ElementRef;
  setFocus(): void {
    this.commentInput.nativeElement.focus();
  }

  allStats(){
    this.allData.impression = this.data?.postAnalytics?.impression != null ? this.data?.postAnalytics?.impression : '-';
    this.allData.reactions = this.data?.postAnalytics?.reactions != null ? this.data?.postAnalytics?.reactions : '-';
    this.allData.interactions = this.data?.postAnalytics?.interactions != null ? this.data?.postAnalytics?.interactions : '-';
    this.allData.shares = this.data?.postAnalytics?.shares != null ? this.data?.postAnalytics?.shares : '-';
    this.allData.comments = this.data?.postAnalytics?.comments != null ? this.data?.postAnalytics?.comments : '-';
    this.allData.AffectedMembers = this.data?.postAnalytics?.AffectedMembers != null ? this.data?.postAnalytics?.AffectedMembers : '-';
  }

  gVal(data: any){
    return data && Number(data)? Number(data): '-'
  }

  toNumber(data: any){
    return data && Number(data)? Number(data): 0
  }

  getMetricValue(metric:string,source:any){
    for (let key in source){
      if(key== metric){
        return source[key]
      }
    }
    //handling metrics for facebook
    if(source.metrics && source.metrics.length > 0){
      for(let m of source.metrics){
        if(m.name == metric && m.value !== undefined && m.value !== null){
          return m.value
        }
      }
    }
    // console.log("getMetricValue",metric,source)
    return 0
  }

  renderVal(data: any){

    return !isNaN(data) ? data: 0
  }

  renderInstaVal(name: string){

		try {
			const insight = this.instagramInsights?.postAnalytics?.find((insight: any)=> insight.name == name)
      if(!insight)console.log(name,insight)
			return insight ? insight.value : '-'
		} catch(error) {
			return '-'
		}
	}

	@ViewChild('actionDropdownContainer') actionDropdownContainer!: ElementRef;
	private documentClickListener: (() => void) | null = null;

	toggleActionDropdown(event: MouseEvent | null = null) {
		event?.stopPropagation(); // Prevent the click from bubbling to the document listener
    this.actionDropdown = !this.actionDropdown;

    if (this.actionDropdown) {
      this.documentClickListener = this.renderer.listen('document', 'click', (event) => {

        // Check if the click is outside the dropdown container
        if (!this.actionDropdownContainer.nativeElement.contains(event.target)) {
          this.closeActionDropdown();
        }
      });
    } else {
      this.removeDocumentClickListener();
    }
  }

	closeActionDropdown() {
    this.actionDropdown = false;
    this.removeDocumentClickListener();
  }

  private removeDocumentClickListener() {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
    }
  }

  override ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.removeDocumentClickListener(); // Clean up when the component is destroyed
  }


	useAsNewPostTemplate() {

		const postId = this.data.id
    const mediaQuery = `/posts?useAs=update&postId=${postId}`;

    Debug.log(mediaQuery);
    window.location.href = mediaQuery;
  }

  sumFBPostAnalytics(){

    this.facebookInsights.postAnalytics.shares = this.sumFBPagesInsightsByName("shares")
    this.facebookInsights.postAnalytics.comments = this.sumFBPagesInsightsByName("comments")
    this.facebookInsights.postAnalytics.reactions = this.sumFBPagesInsightsByName("reactions")
    this.facebookInsights.postAnalytics.Interactions = this.sumFBPagesInsightsByName("Interactions")

    for(let i = 0; i<3; i++){
      this.facebookInsights.postAnalytics.metrics[i].value = this.toNumber(this.facebookInsights?.postAnalytics?.metrics[i].value) + this.toNumber(this.facebookData?.postAnalytics?.metrics[i].value)
    }
  }

  sumFBPagesInsightsByName(name: string){
    let sum = 0;
    this.facebookData.forEach((page: any) => {
      sum += this.toNumber(page.postAnalytics[name])
    });
    return sum
  }

  sumLinkedinPostAnalytics(){
    this.linkedinInsights.postAnalytics.impressionCount = this.toNumber(this.linkedinInsights?.postAnalytics?.impressionCount) + this.toNumber(this.linkedinData?.postAnalytics?.impressionCount)
    this.linkedinInsights.postAnalytics.totalEngagement = this.toNumber(this.linkedinInsights?.postAnalytics?.totalEngagement) + this.toNumber(this.linkedinData?.postAnalytics?.totalEngagement)
    this.linkedinInsights.postAnalytics.engagementRate = this.toNumber(this.linkedinInsights?.postAnalytics?.engagementRate) + this.toNumber(this.linkedinData?.postAnalytics?.engagementRate)
    this.linkedinInsights.postAnalytics.clickCount = this.toNumber(this.linkedinInsights?.postAnalytics?.clickCount) + this.toNumber(this.linkedinData?.postAnalytics?.clickCount)
    this.linkedinInsights.postAnalytics.clickRate = this.toNumber(this.linkedinInsights?.postAnalytics?.clickRate) + this.toNumber(this.linkedinData?.postAnalytics?.clickRate)
    this.linkedinInsights.postAnalytics.likeCount = this.toNumber(this.linkedinInsights?.postAnalytics?.likeCount) + this.toNumber(this.linkedinData?.postAnalytics?.likeCount)
    this.linkedinInsights.postAnalytics.commentCount =  this.toNumber(this.linkedinData.map((ld:any)=>ld.postAnalytics?.commentCount).reduce((acc:number,curr:number)=>acc+curr,0))
    this.linkedinInsights.postAnalytics.shareCount = this.toNumber(this.linkedinInsights?.postAnalytics?.shareCount) + this.toNumber(this.linkedinData?.postAnalytics?.shareCount)
  }

  suminstagramPostAnalytics(){
    try{

      if(this.instagramInsights?.postAnalytics)
        this.instagramInsights?.postAnalytics.forEach((stat1 : any) => {
					const stat2 = this.instagramData?.postAnalytics?.find((stat: any) => stat.name === stat1.name);
					if (stat2) {
						stat1.value = this.toNumber(stat1.value) + this.toNumber(stat2.value);  // Additionner la valeur dans obj1
					}
				});
		} catch(errr){
			console.log("instagram insight error")
		}
  }

	dateFormatingComments(dateString:string){
		const date = new Date(dateString);

		// Extract parts of the date
		const day = date.getDate();
		const month = date.toLocaleString('en-US', { month: 'short' });
		const year = date.getFullYear().toString().slice(-2);
		const hours = date.getHours().toString().padStart(2, '0');
		const minutes = date.getMinutes().toString().padStart(2, '0');

		// Combine into the desired format
		return `${day} ${month} ${year}, ${hours}:${minutes}`;
	}

	dateFormatingPost(dateString:string){
		const date = new Date(dateString);

		const now = new Date();
		const today = now.getDate();
		const tomorrow = today + 1;
		const yesterday = today - 1;

		// Extract parts of the date
		const day = date.getDate();
		const month = date.toLocaleString('en-US', { month: 'short' });
		const year = date.getFullYear().toString().slice(-2);
		const hours = date.getHours().toString().padStart(2, '0');
		const minutes = date.getMinutes().toString().padStart(2, '0');

		// Combine into the desired format
		// return this.translationService.t('dates.relative.today') + ' ' + this.translationService.t('pages.at') + ` ${hours}:${minutes}`;
		// Combine into the desired format
		if (day == today) {
			return this.translationService.t('dates.relative.today') + ' ' + this.translationService.t('pages.at') + ` ${hours}:${minutes}`;
		} else if (day == tomorrow) {
			return this.translationService.t('dates.relative.tomorrow') + ' ' + this.translationService.t('pages.at') + ` ${hours}:${minutes}`;
		} else if (day == yesterday) {
			return this.translationService.t('dates.relative.yesterday') + ' ' + this.translationService.t('pages.at') + ` ${hours}:${minutes}`;
		} else {
			return this.translationService.t('dates.relative.onThe') + ` ${day} ${month} ${year}, ` + this.translationService.t('pages.at') + ` ${hours}:${minutes}`;
		}
	}

	preparePostDataForPreview(data: any): any {
		const googleSocialMedia = data.SocialPlatforms.find((sm: any) => sm.source === "google");

		return {
			typePost: data?.typePost,
			text: data?.text,
			title: data?.title,
      date: data?.publishingDatetime,
			googleEventOfferStartDate: null, // Not present in the input object
			googleEventOfferEndDate: null, // Not present in the input object
			googleBtnValue: googleSocialMedia?.additionalData?.callToAction?.actionType, // Not present in the input object
			socialMedia: data?.SocialPlatforms, // Extracting sources like "linkedin"
			createdAt: data?.createdAt,
			mediaGoogle: googleSocialMedia?.medias?.[0]?.url || null, // First media URL if available
			mediaList: data?.SocialPlatforms?.[0]?.medias?.filter(
				(media:any) =>
					media?.mimeType?.toLowerCase().startsWith('image') || media?.mimeType?.toLowerCase().startsWith('photo') ||media?.mimeType?.toLowerCase().startsWith('video')
			) || [], // Filtering media with image-like MIME types
		};
	}

  reinitializeData(){
    this.linkedinInsights = {};
    this.facebookInsights = {};
    this.instagramInsights = {};
    this.data = {};
    this.selectedPlateform = '';
    this.writeReply = null;
    this.pages = [];
    this.platformPages = [];
    this.all = false;
    this.linkedinPages = [];
    this.googlePages = [];
    this.facebookPages = [];
    this.instagramPages = [];
    this.linkedinData = null;
    this.googleData = null;
    this.facebookData = null;
    this.instagramData = [];
    this.allData = {};
    this.nbOfLinkedindPages = 1;
    this.groups = [];

  }

  // Method to check if an object is empty
  isNotEmptyObject(obj: any): boolean {
    return obj && typeof obj === 'object' && Object.keys(obj).length !== 0;
  }

  groupsNames(): string{
    let groupsNames = '';
    if(this.groups.length > 0)
      for(let i =0; i< this.groups.length; i++){
        groupsNames +=  this.groups[i]?.name
        groupsNames += i!=this.groups.length-1?', ':''
      }
    return groupsNames
  }

  addGroupsToNavBar(){
    if(this.groups.length>0){
      this.groups.forEach((item: any)=>{
        this.groupScopes.push(item.id)
      })
      this.postService.updateGroups(this.groupScopes)
      this.postService.saveGroupScopesToLocalStorage(this.groupScopes)
      // window.location.reload();
      this.postService.emitEvente('update caption');

    }
  }

  countFbComments(fbPost: any){
    // console.log("✅",fbPost);

    let nbOfComments = 0;
    fbPost.comments.forEach((comment: any)=>{
      if(comment?.replies){
        nbOfComments += comment?.replies.length
        comment.replies.forEach((rr: any) => {
          if(rr?.replies)
            nbOfComments += rr?.replies.length
        });
      }
    })
    return nbOfComments + fbPost.comments.length
  }

  countLiComments(liPost:any){
    let nbOfComments = 0;
    liPost.comments.forEach((comment: any)=>{
      if(comment?.replies){
        nbOfComments += comment?.replies.length
        comment.replies.forEach((rr: any) => {
          if(rr?.replies)
            nbOfComments += rr?.replies.length
        });
      }
    })
    return nbOfComments + liPost.comments.length
  }
  onDataReceived(data: boolean) {
    this.reactionsView = data;
  }
  facebookReactionDetails:any[] = []
  calculFbInteractions(value: any){
    console.log("calculFbInteractions",value.reactionDetails);
    this.facebookReactionDetails=[...this.facebookReactionDetails,value.reactionDetails]
    let reactions = 0
    for(let reac in value?.metrics[4]?.value){
      reactions += this.toNumber(value?.metrics[4]?.value[reac])
    }
    value.Interactions = this.toNumber(value?.shares) + this.toNumber(value?.comments) + reactions

  }



	confirmPostRemoval(event: any) {
		this.modalHideElements = true
		this.modalShowLoadingDots = true
		this.modalIcon = ICON.delete;
		this.modalHeading = 'posts.postBeingDeleted';
		this.modalSubHeading = ' ';
		// Mark the post as "deletion in progress"
		// this.currentPost.deletionInProgress = true;

		// const index = this.posts.findIndex((post:any) => post.id === this.currentPost.id);
    // if (index !== -1) {
    //   this.posts.splice(index, 1);
    // }
		// if (index !== -1)
		// 	this.posts[index].deletionInProgress = true;

		// Call the delete function
		this.deletePost(this.data, event?.selected || null);
	}

	private deletionJobCounts = new Map<number, number>(); // keep track of which post was deleted and how many times (i.e. on how many pages)

	deletePost(post: any, selectedSocialMediasIds: any[] | null) {
    console.log(`deleting post `, post);

		// Initialize the job count for the post
    if (selectedSocialMediasIds) {
      this.deletionJobCounts.set(post.id, selectedSocialMediasIds.length);
    }

    this.subscriptions.push(this.postService.deletePost(post, selectedSocialMediasIds).subscribe((res) => {
      if (res.success) {
        //change modal icon and heading and hide them after 1.5 s
        this.modalIcon = ICON.delete;
        this.modalHeading = 'posts.postBeingDeleted';
        this.modalSubHeading = ' ';
      }
    }));
  }


  isInstagramInsightsDisabled(){
    return environment.TMP_INSTAGRAM_INSIGHTS_DISABLED
  }

	userHasPermission(permission: string): boolean {
		return (
			this.user?.isAdmin ||
			this.user?.accreditations[0]?.profile?.permissions.some((profilePermission: any) => profilePermission.action == permission)
		)
	}

	currentPostAvatarFt(): string | null {
		if (this.writeReply.avatar) return this.writeReply.avatar;

		if (this.writeReply.isCommentByPage && this.targetPage?.pageLogoUrl) {
			return this.targetPage.pageLogoUrl;
		}

		return null;
	}

}
